import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as classes from './classes.module.scss';

const renderImage = (src, alt) => (src
  ? (<img alt={ alt } src={ src } />)
  : (<div className={ classes.placeHolder } />)
);

const SelectableFrame = ({
  frameId, currentFrameId, setFrameFromOption, frameThumbUrl, frame, mount, frameMatColorName
}) => (
  <div
    className={ classnames(classes.frame, { [classes.selected]: (frameId === currentFrameId) }) }
    onClick={ () => setFrameFromOption(frameId, mount, frameMatColorName) }
  >
    { renderImage(frameThumbUrl, frame) }
  </div>
);

SelectableFrame.propTypes = {
  frameId: PropTypes.number,
  currentFrameId: PropTypes.number,
  frameThumbUrl: PropTypes.string,
  frame: PropTypes.string,
  setFrameFromOption: PropTypes.func.isRequired,
  mount: PropTypes.string,
  frameMatColorName: PropTypes.string
};

export default SelectableFrame;
